import React from 'react';
import ComponentRegistry from "../../Common/ComponentRegistry";

export default class PanelController extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            matrix: []
        };
        this.store = ComponentRegistry.getStore("ProductCompareStore");
        this.store.listen(state => this.setState(state));
    }

    render() {
        const View = ComponentRegistry.get("ProductCompareViewsPanelView");

        return (
            <View {...this.props} {...this.state} onRemove={product => this.store.remove(product)} />
        );
    }
}



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductCompare/Controllers/PanelController.jsx